export default __webpack_public_path__ + "static/137-329bd390f451909e7d8cada48fdebb37.jpg";